(function () {
  function initHoverMenu() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    var menuItems = nav.querySelectorAll(':scope > ul > li');
    var closeTimer;

    function closeAllMenus() {
      nav.querySelectorAll('details[open]').forEach(function (d) {
        d.removeAttribute('open');
        d.open = false;
      });
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAllMenus, 150);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    menuItems.forEach(function (li) {
      var details = li.querySelector(':scope > header-menu > details, :scope > details');
      if (!details) return;

      li.addEventListener('mouseenter', function () {
        cancelClose();
        nav.querySelectorAll('details[open]').forEach(function (d) {
          if (d !== details) {
            d.removeAttribute('open');
            d.open = false;
          }
        });
        details.setAttribute('open', '');
        details.open = true;
      });

      var summary = details.querySelector(':scope > summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }
    });

    // Cierra el menu cuando el mouse sale de TODA la barra de navegacion
    // (no de cada <li> por separado). Esto evita que el menu se quede
    // "pegado" abierto: antes, el panel desplegado (posicionado fixed a
    // todo el ancho) podia perder el seguimiento del mouseleave del <li>
    // pequeno que lo abre, y el menu nunca recibia la señal de cierre.
    nav.addEventListener('mouseenter', cancelClose);
    nav.addEventListener('mouseleave', scheduleClose);

    // Redes de seguridad: un menu abierto nunca deberia sobrevivir a un
    // scroll de la pagina ni a un click fuera de el.
    window.addEventListener('scroll', closeAllMenus, { passive: true });
    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target)) closeAllMenus();
    });
  }

  document.addEventListener('DOMContentLoaded', initHoverMenu);
})();
